import gql from 'graphql-tag';

export default gql`
  query AppleIDClientSecret($clientId: ID!) {
    appleIDClientSecret(clientId: $clientId)
  }
`;
